import { ImportantFootnote } from '../common/ImportantFootnote'
import { ProfileCTAButton } from './ProfileCTAButton'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { ProfilePriceContainer } from '../common/ProfilePriceContainer'

type ProfileBioSectionProps = {
  profile: MemberProfileExtendedType
}

export function ProfileBioSection({ profile }: ProfileBioSectionProps) {
  return (
    <div className='bg-white border-[#D9E2F4] border mr-3 h-fit min-h-[500px] w-fit rounded-3xl shadow-[0px_0px_30px_0px_rgba(217,226,244,1)]'>
      <div className='max-md:hidden flex justify-end -mt-[90px] items-center gap-1'>
        <ProfilePriceContainer hourlyRate={profile.core.hourly_rate} />
        <ProfileCTAButton
          className='h-[32px] sm:w-[116px] xl:w-[166px]'
          profile={profile}
        />
      </div>
      <div className='p-[30px] md:mt-[70px]'>
        <h3 className='text-lg font-bold text-[#001A3D]'>
          About {profile.displayName}
        </h3>
        <p className='text-[#4A505C] mt-4'>{profile.core.bio}</p>
        <hr className='mt-4 mb-4'></hr>
        <ImportantFootnote
          className='text-xs'
          text='None of the information in this professional biography has been reviewed or verified by Legal Utopia.'
        />
      </div>
    </div>
  )
}
